import AOS from 'aos';
import 'aos/dist/aos.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './src/styles/global.css'
import './src/styles/custom.css';

AOS.init();
